import styles from './LandingFooter.module.css'

const columns = [
  {
    title: 'Produto',
    links: ['Como funciona', 'Planos e preços', 'Novidades', 'API'],
  },
  {
    title: 'Empresa',
    links: ['Sobre nós', 'Blog', 'Contato', 'Imprensa'],
  },
  {
    title: 'Legal',
    links: ['Termos de uso', 'Privacidade', 'Cookies'],
  },
]

export function LandingFooter() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div>
          <div className={styles.brand} aria-label="Fantyx.Pro">
            <svg
              className={styles.brandBolt}
              viewBox="0 0 120 120"
              aria-hidden="true"
              focusable="false"
            >
              <polygon points="14,14 38,14 106,106 82,106" fill="var(--acc)" />
              <polygon points="14,106 30,106 106,30 106,14 90,14 14,90" fill="var(--text-1)" />
            </svg>
            <span className={styles.brandWordmark}>
              <span className={styles.brandFanty}>FANTY</span>
              <span className={styles.brandX}>X</span>
              <span className={styles.brandPro}>.PRO</span>
            </span>
          </div>
          <p className={styles.tagline}>
            A plataforma de fantasy sports mais flexível do Brasil. Feita para a Copa de Seleções 2026 e além.
          </p>
        </div>
        {columns.map((col) => (
          <div key={col.title}>
            <div className={styles.colTitle}>{col.title}</div>
            <ul className={styles.links}>
              {col.links.map((link) => (
                <li key={link}>{link}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className={styles.bottom}>
        <span>© 2026 Fantyx.Pro. Todos os direitos reservados.</span>
        <span>Desenvolvido no Brasil 🇧🇷 para a Copa de Seleções 2026</span>
      </div>
    </footer>
  )
}
